import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { NavigationService, NavigationServiceModule } from '@b2b/common/services/navigation/navigation.service';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { ILogService, IScope, ITimeoutService } from 'angular';

NavigationDirective.$inject = [];

function NavigationDirective() {
  NavigationController.$inject = [
    '$scope',
    '$state',
    '$log',
    '$timeout',
    'AuthService',
    'AuthenticationService',
    'NavigationService',
    'ThemesHelperService',
    'FeatureToggleService',
  ];

  function NavigationController(
    $scope: IScope & { navigation: TODO },
    $state: StateService,
    $log: ILogService,
    $timeout: ITimeoutService,
    AuthService: TODO,
    authenticationService: AuthenticationService,
    navigationService: NavigationService,
    themesHelperService: ThemesHelperService,
    FeatureToggleService: TODO
  ) {
    const user = authenticationService.getUserFromCookie();

    $scope.navigation = navigationService;

    $scope.navigation.getHomeLink = AuthService.getHomeUrl();

    $scope.navigation.hasCart = FeatureToggleService.check('TENANT_CART');

    $scope.navigation.companyName = themesHelperService.getCompany('name');

    $scope.navigation.getUserFullName = function () {
      return authenticationService.getUserFullName();
    };

    $scope.navigation.getItemSref = function (item) {
      return Array.isArray(item.items) && item.items[0] && item.items[0].sref ? item.items[0].sref : item.sref;
    };

    $scope.navigation.hasActiveNestedState = function (link, parentStateIndex) {
      let hasNestedStates = false;
      let splitState = [];
      const stateName = link.sref;
      const toggleState = link.toggleOnState;
      let parentState = link.parentState || stateName;
      const nestedStates = link.nested;

      if (Array.isArray(nestedStates)) {
        if (nestedStates.indexOf($state.current.name) >= 0) {
          hasNestedStates = true;
        }
      }

      if (stateName) {
        if (parentStateIndex) {
          splitState = stateName.split('.');
          splitState.splice(-1);
          parentState = splitState.join('.');
        }
      } else if (toggleState) {
        parentState = toggleState;
      } else {
        // No state available to activate
        return false;
      }

      return hasNestedStates || $state.current?.name?.indexOf(parentState) === 0;
    };

    $scope.navigation.action = function (link, action) {
      if (action === 'toggle') {
        console.log('Navigation -> $scope.navigation.action', link, action);
        for (let i = 0, ii = this.current.length; i < ii; i++) {
          if (link !== this.current[i]) {
            this.current[i].toggle = false;
          }
        }

        link.toggle = !link.toggle;
      }
    };

    $scope.navigation.hasIcon = function (item) {
      const classes: Record<string, string> = {};
      if (item.icon) {
        classes[item.icon] = item.icon;
        classes.icon = item.icon;
      }
      return classes;
    };

    $scope.navigation.hasSubItems = function (item) {
      const hiddens = [];
      if (item.items) {
        item.items.filter(function (subItem) {
          return subItem.hidden;
        });
      }
      return item.items && item.items.length > hiddens.length ? true : false;
    };

    $scope.navigation.isExpanded = function (item) {
      const self = $scope.navigation;
      return self.hasActiveNestedState(item) && self.hasSubItems(item);
    };

    $scope.navigation.isCurrentlySelected = function (item) {
      const self = $scope.navigation;
      return self.hasActiveNestedState(item) && !self.hasSubItems(item);
    };

    $scope.navigation.isSubItemCurrentlySelected = function (sref) {
      return $state.current.name === sref;
    };

    $scope.navigation.isSubItemSelected = function (item) {
      if (item.hasOwnProperty('selected') && Array.isArray(item.selected)) {
        return item.selected.indexOf($state.current.name) != -1;
      } else {
        return $state.current.name === item.sref;
      }
    };

    $scope.navigation.toggle = user && user.hasOwnProperty('email');
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/navigation/navigationSidebar.tpl.html',
    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: NavigationController,
  };
}

export const NavigationDirectiveModule = angular
  .module('acme.common.directive.navigation', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.auth',
    AuthenticationServiceModule,
    NavigationServiceModule,
    'acme.common.service.themesHelper',
    'acme.common.directive.feature',
  ])
  .directive('navigation', NavigationDirective).name;
